import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { Loader2, Lock } from "lucide-react";
import { useContent } from "../context/ContentContext";
import { API } from "../data/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { content } = useContent();
  const COMPANY = content.company;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("ci_token", data.token);
      localStorage.setItem("ci_user", JSON.stringify(data.user));
      navigate("/admin");
    } catch (err) {
      setError(err.response?.data?.detail || "Accesso non riuscito");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-transparent border-b border-paper/20 py-3 text-paper placeholder:text-paper/35 focus:outline-none focus:border-gold transition-colors";

  return (
    <div className="min-h-screen bg-navy-deep grain flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10 w-full max-w-md"
      >
        <div className="text-center mb-10">
          <img src={COMPANY.logo} alt="Cancella Infissi" className="h-20 w-auto object-contain bg-paper/95 p-3 inline-block" />
          <p className="eyebrow mt-6">Area riservata</p>
          <h1 className="font-serif font-light text-4xl text-paper mt-2">Accesso amministratore</h1>
        </div>

        <form onSubmit={submit} data-testid="admin-login-form" className="space-y-7 bg-navy/40 border border-gold/15 p-8">
          <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className={inputCls} />
          <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className={inputCls} />
          {error && <p data-testid="admin-login-error" className="text-red-400 text-sm">{error}</p>}
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-3 bg-gold text-navy py-4 text-xs uppercase tracking-[0.22em] hover:bg-gold-soft transition-colors disabled:opacity-60"
          >
            {loading ? <Loader2 className="animate-spin" size={16} /> : <Lock size={15} />} Entra
          </button>
        </form>
        <a href="/" className="block text-center mt-8 text-paper/40 text-xs uppercase tracking-[0.2em] hover:text-gold transition-colors">
          ← Torna al sito
        </a>
      </motion.div>
    </div>
  );
}
